import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SeoService } from '@web-client/shared';

@Component({
  selector: 'lib-not-found',
  standalone: true,
  imports: [CommonModule, RouterLink, MatButtonModule, MatCardModule],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent implements OnInit, OnDestroy {
  redirectUri: string | null = null;
  countdown = 5;
  private countdownInterval: ReturnType<typeof setInterval> | null = null;

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly seoService = inject(SeoService);

  ngOnInit(): void {
    // Check for the 'redirectUri' query parameter
    this.seoService.removeCanonicalURL();

    this.route.queryParamMap.subscribe(params => {
      this.redirectUri = params.get('redirectUri');

      // If a redirectUri exists, start the countdown
      if (this.redirectUri) {
        this.startCountdown();
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up the interval when the component is destroyed
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval as any);
    }
  }

  private startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval as any);
        if (this.redirectUri) {
          this.router.navigateByUrl(this.redirectUri);
        }
      }
    }, 1000); // Update every second
  }

  cancelRedirect(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval as any);
    }
    // Setting redirectUri to null will hide the countdown message in the template
    this.redirectUri = null;
  }
}